import { Box, Image, Stack, Text } from "@mantine/core";
import { IconPhoto } from "@tabler/icons-react";

// Şeffaf PNG/SVG düz zeminde kayboluyordu — damalı zemin logonun nerede bittiğini ve arkasının
// gerçekten şeffaf olup olmadığını gösteriyor. Varlık yöneticilerinin standart çözümü.
export const CHECKER_BACKGROUND = {
  backgroundImage:
    "linear-gradient(45deg, var(--mantine-color-gray-2) 25%, transparent 25%)," +
    "linear-gradient(-45deg, var(--mantine-color-gray-2) 25%, transparent 25%)," +
    "linear-gradient(45deg, transparent 75%, var(--mantine-color-gray-2) 75%)," +
    "linear-gradient(-45deg, transparent 75%, var(--mantine-color-gray-2) 75%)",
  backgroundSize: "14px 14px",
  backgroundPosition: "0 0, 0 7px, 7px -7px, -7px 0",
};

// Damalı zeminde ortalanmış görsel kutusu. Marka ayarlarındaki çıktı kartları ve kırpma
// penceresindeki önizleme aynı kutuyu paylaşıyor.
export function ImagePreview({ src, alt, height, empty }) {
  return (
    <Box
      h={height}
      style={{
        ...CHECKER_BACKGROUND,
        borderRadius: "var(--mantine-radius-md)",
        border: "1px solid var(--mantine-color-gray-2)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      {src ? (
        <Image
          src={src}
          alt={alt}
          mah={height - 20}
          maw="88%"
          fit="contain"
          fallbackSrc={null}
        />
      ) : (
        <Stack align="center" gap={2} c="dimmed" px="xs">
          <IconPhoto size={26} stroke={1.4} />
          <Text size="xs" ta="center">
            {empty}
          </Text>
        </Stack>
      )}
    </Box>
  );
}
